<app-side-menu>
  <div class="b2b-ops-page">
    <div class="page-header">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
        <div>
          <button *ngIf="contractId" type="button" class="btn-back" (click)="backToContract()">
            <i class="fas fa-arrow-left"></i>
          </button>
          <button *ngIf="step !== 'hub'" type="button" class="btn-back" (click)="closeWizard()">
            <i class="fas fa-times"></i>
          </button>
          <h1 class="page-title">
            <i class="fas fa-balance-scale me-2"></i>
            {{ step === 'hub' ? 'Fechamento B2B' : wizardTitle }}
          </h1>
          <p class="page-subtitle">
            {{ formatPeriodLabel(periodStart) }} → {{ formatPeriodLabel(periodEnd) }}
            <span *ngIf="contractDisplayName"> — {{ contractDisplayName }}</span>
            <span *ngIf="contractNumber && contractDisplayName !== contractNumber" class="opacity-75"> ({{ contractNumber }})</span>
          </p>
        </div>
        <button *ngIf="step === 'hub'" type="button" class="btn btn-light fw-semibold" (click)="openWizard()">
          <i class="fas fa-magic me-2"></i>Gerar fechamento
        </button>
      </div>
    </div>

    <!-- ===================== HUB ===================== -->
    <ng-container *ngIf="step === 'hub'">
      <div class="b2b-ops-card mb-3">
        <div class="b2b-ops-filters">
          <div class="form-group">
            <label class="form-label">Início do período</label>
            <input class="form-control" type="date" [(ngModel)]="periodStart" (change)="onPeriodChange()">
          </div>
          <div class="form-group">
            <label class="form-label">Término do período</label>
            <input class="form-control" type="date" [(ngModel)]="periodEnd" (change)="onPeriodChange()">
          </div>
          <div class="form-group">
            <label class="form-label">Competência (rótulo)</label>
            <input class="form-control" type="text" [value]="(filterMonth | number:'2.0-0') + '/' + filterYear" readonly>
          </div>
          <div class="form-group align-self-end">
            <button type="button" class="btn btn-outline-secondary" (click)="applyFilters()" [disabled]="loading">
              Atualizar espelho
            </button>
          </div>
        </div>
      </div>

      <div class="closing-hub-stats" *ngIf="preview">
        <div class="closing-stat">
          <span class="label">Total prévia</span>
          <span class="value">{{ formatMoney(preview.competenceTotal) }}</span>
        </div>
        <div class="closing-stat">
          <span class="label">Pedidos / veículos</span>
          <span class="value">{{ preview.eligibleItemCount || 0 }} / {{ preview.eligibleVehicleCount || 0 }}</span>
        </div>
        <div class="closing-stat">
          <span class="label">Rascunhos</span>
          <span class="value">{{ drafts.length }}</span>
        </div>
      </div>

      <div class="b2b-ops-card mb-3" *ngIf="preview && mirrorCategories.length">
        <h3 class="mb-2">Espelho do período</h3>
        <div class="mirror-breakdown">
          <div class="mirror-cat" *ngFor="let cat of mirrorCategories">
            <div class="mirror-cat-head">
              <strong>{{ cat.categoryLabel }}</strong>
              <span>{{ cat.lineCount }} linha(s) · {{ formatMoney(cat.totalAmount) }}</span>
            </div>
            <ul class="mirror-sample" *ngIf="cat.sampleLines.length">
              <li *ngFor="let line of cat.sampleLines">
                <span>{{ line.plate || '—' }}</span>
                — {{ line.description || '—' }}
                <strong class="ms-1">{{ formatMoney(line.amount) }}</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="b2b-ops-card">
        <div class="closing-cta-row">
          <div>
            <h3 class="mb-1">Rascunhos da competência</h3>
            <p>O fechamento roda em tela cheia (espelho → tipo → lançamento se necessário → prévia → export).</p>
          </div>
          <button type="button" class="btn btn-success" (click)="openWizard()">
            <i class="fas fa-play me-1"></i> Abrir assistente
          </button>
        </div>

        <div *ngIf="!loading && !drafts.length" class="b2b-ops-empty">
          <i class="fas fa-file-invoice"></i>
          <h3>Nenhum rascunho ainda</h3>
          <p>Clique em <strong>Gerar fechamento</strong> para abrir o assistente.</p>
        </div>

        <div class="draft-list" *ngIf="!loading && drafts.length">
          <div
            class="draft-row"
            *ngFor="let d of drafts"
            [class.active]="selectedDraft?.id === d.id"
            (click)="selectDraft(d)">
            <div>
              <strong>{{ d.invoiceNumber }}</strong>
              <div class="meta">
                {{ d.categoryLabel || d.category }} · {{ formatMoney(d.totalAmount) }}
              </div>
            </div>
            <div class="d-flex gap-2">
              <button type="button" class="btn btn-sm btn-outline-success" (click)="selectDraft(d); exportDraft('xlsx'); $event.stopPropagation()">Excel</button>
              <button type="button" class="btn btn-sm btn-outline-danger" (click)="selectDraft(d); exportDraft('pdf'); $event.stopPropagation()">PDF</button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- ===================== WIZARD FULL PAGE ===================== -->
    <ng-container *ngIf="step !== 'hub'">
      <div class="b2b-ops-card mb-3">
        <div class="b2b-ops-filters mb-3">
          <div class="form-group">
            <label class="form-label">Início</label>
            <input class="form-control" type="date" [(ngModel)]="periodStart" (change)="onPeriodChange()">
          </div>
          <div class="form-group">
            <label class="form-label">Término</label>
            <input class="form-control" type="date" [(ngModel)]="periodEnd" (change)="onPeriodChange()">
          </div>
          <div class="form-group align-self-end">
            <button type="button" class="btn btn-outline-primary btn-sm" (click)="applyFilters()" [disabled]="loading">
              Recarregar período
            </button>
          </div>
        </div>

        <div class="wizard-stepper">
          <button type="button" class="wizard-step" [class.active]="step==='mirror'" [class.done]="stepIndex>0" (click)="goStep('mirror')">1. Espelho</button>
          <button type="button" class="wizard-step" [class.active]="step==='type'" [class.done]="stepIndex>1" (click)="goStep('type')">2. Tipo</button>
          <button
            *ngIf="needsLaunchStep"
            type="button"
            class="wizard-step"
            [class.active]="step==='launch'"
            [class.done]="stepIndex>2"
            (click)="goStep('launch')">
            3. Lançamento
          </button>
          <button type="button" class="wizard-step" [class.active]="step==='preview'" [class.done]="step==='drafts'" (click)="goStep('preview')" [disabled]="!selectedCategory">
            {{ needsLaunchStep ? '4' : '3' }}. Prévia
          </button>
          <button type="button" class="wizard-step" [class.active]="step==='drafts'" (click)="goStep('drafts')">
            {{ needsLaunchStep ? '5' : '4' }}. Rascunho
          </button>
        </div>
      </div>

      <div *ngIf="loading" class="b2b-ops-card">Carregando espelho…</div>
      <div class="diag-banner info" *ngIf="!loading && preview?.diagnosticMessage">{{ preview?.diagnosticMessage }}</div>

      <!-- MIRROR -->
      <div class="b2b-ops-card wizard-panel" *ngIf="!loading && step==='mirror' && preview">
        <h3>
          Espelho {{ formatPeriodLabel(periodStart) }} → {{ formatPeriodLabel(periodEnd) }}
          <small class="text-muted">(competência {{ preview.competenceMonth }}/{{ preview.competenceYear }})</small>
        </h3>
        <p class="lead">
          {{ preview.eligibleVehicleCount || 0 }} veículo(s) ·
          Total estimado: <strong>{{ formatMoney(preview.competenceTotal) }}</strong>
        </p>

        <div class="diag-banner" *ngIf="!mirrorCategories.length">
          Nenhuma cobrança elegível neste período. Multas, avarias, caução e orçamentos aprovados
          aparecem automaticamente quando existem no contrato; telemetria, acessórios e moto reserva
          precisam de lançamento no passo seguinte.
        </div>

        <div class="mirror-breakdown" *ngIf="mirrorCategories.length">
          <div class="mirror-cat" *ngFor="let cat of mirrorCategories">
            <div class="mirror-cat-head">
              <strong>{{ cat.categoryLabel }}</strong>
              <span>{{ cat.lineCount }} linha(s) · {{ formatMoney(cat.totalAmount) }}</span>
            </div>
            <ul class="mirror-sample" *ngIf="cat.sampleLines.length">
              <li *ngFor="let line of cat.sampleLines">
                <span>{{ line.plate || '—' }}</span>
                — {{ line.description || '—' }}
                <strong class="ms-1">{{ formatMoney(line.amount) }}</strong>
              </li>
            </ul>
          </div>
        </div>

        <div class="wizard-actions">
          <button type="button" class="btn btn-outline-secondary" (click)="closeWizard()">Voltar ao hub</button>
          <button type="button" class="btn btn-success" (click)="goStep('type')">Continuar — escolher tipo</button>
        </div>
      </div>

      <!-- TYPE -->
      <div class="b2b-ops-card wizard-panel" *ngIf="!loading && step==='type'">
        <h3>Que tipo de fechamento deseja fazer?</h3>
        <p class="lead">
          Aluguel, telemetria, acessórios e moto reserva abrem lançamento com as placas do contrato antes da prévia.
          Multas, avarias, caução e sinistro entram automaticamente do período.
        </p>
        <div class="category-grid">
          <button
            type="button"
            class="category-card"
            *ngFor="let cat of categories"
            [class.selected]="selectedCategory === cat.value"
            (click)="chooseCategory(cat.value)">
            {{ cat.label }}
          </button>
        </div>
      </div>

      <!-- LAUNCH TELEMETRY -->
      <div class="b2b-ops-card wizard-panel" *ngIf="step==='launch' && selectedCategory==='Telemetry'">
        <h3>Lançar telemetria por placa</h3>
        <p class="lead">
          Placas do contrato com rastreador. <strong>Valor unitário = mensalidade</strong> (mês comercial de 30 dias).
          Use <em>Selecionar todos</em>, pesquise e aplique um valor (ex.: R$ 50) nas selecionadas.
        </p>
        <div *ngIf="launching" class="text-muted py-3">Carregando placas…</div>
        <div class="launch-toolbar" *ngIf="!launching && launchLines.length">
          <label class="launch-check">
            <input type="checkbox" [(ngModel)]="allFilteredLaunchSelected">
            Selecionar todos ({{ filteredLaunchLines.length }})
          </label>
          <input class="form-control form-control-sm launch-search" type="search" placeholder="Pesquisar placa…" [(ngModel)]="launchSearch">
          <input class="form-control form-control-sm launch-bulk" type="number" min="0" step="0.01" placeholder="Valor p/ todos" [(ngModel)]="bulkUnitAmount">
          <button type="button" class="btn btn-sm btn-outline-primary" (click)="applyBulkUnitToSelected()">Aplicar valor</button>
        </div>
        <div class="lines-scroll" *ngIf="!launching && launchLines.length">
          <table class="table table-sm align-middle">
            <thead>
              <tr>
                <th></th>
                <th>Placa</th>
                <th>Pedido</th>
                <th>Valor veículo</th>
                <th>Qtd</th>
                <th>Mensal (R$)</th>
                <th class="text-end">Total período</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let line of filteredLaunchLines">
                <td><input type="checkbox" [(ngModel)]="line.selected"></td>
                <td>{{ line.plate || '—' }}</td>
                <td>{{ line.itemNumber || line.b2BContractItemId || '—' }}</td>
                <td>{{ formatMoney(line.vehicleUnitValue) }}</td>
                <td style="max-width:90px"><input class="form-control form-control-sm" type="number" min="0" step="1" [(ngModel)]="line.quantity"></td>
                <td style="max-width:120px"><input class="form-control form-control-sm" type="number" min="0" step="0.01" [(ngModel)]="line.unitAmount"></td>
                <td class="text-end">{{ formatMoney(lineAmount(line)) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="mt-2" *ngIf="!launching">
          <strong>{{ selectedLaunchCount }}</strong> linha(s) ·
          Período {{ telemetryPeriodDays }} dia(s) civis
          (cobrança comercial: {{ telemetryPeriodDays >= 30 ? '30 dias / mensalidade cheia' : (telemetryPeriodDays + ' dia(s) proporcionais') }})
          · Total <strong>{{ formatMoney(launchTotal) }}</strong>
        </p>
        <div class="wizard-actions">
          <button type="button" class="btn btn-outline-secondary" (click)="goStep('type')">Voltar</button>
          <button type="button" class="btn btn-success" [disabled]="saving || launching" (click)="saveLaunchAndContinue()">
            {{ saving ? 'Salvando…' : 'Salvar e ir para prévia' }}
          </button>
        </div>
      </div>

      <!-- LAUNCH RENTAL -->
      <div class="b2b-ops-card wizard-panel" *ngIf="step==='launch' && selectedCategory==='Rental'">
        <h3>Lançar aluguel — veículos do contrato</h3>
        <p class="lead">
          Placas <strong>marcadas neste contrato</strong>. Selecione todas ou algumas, pesquise e aplique valor em lote.
        </p>
        <div *ngIf="launching" class="text-muted py-3">Carregando veículos do contrato…</div>
        <div class="diag-banner" *ngIf="!launching && !launchLines.length">
          Nenhum veículo marcado neste contrato. Cadastre placas nos pedidos e tente de novo.
        </div>
        <div class="launch-toolbar" *ngIf="!launching && launchLines.length">
          <label class="launch-check">
            <input type="checkbox" [(ngModel)]="allFilteredLaunchSelected">
            Selecionar todos ({{ filteredLaunchLines.length }})
          </label>
          <input class="form-control form-control-sm launch-search" type="search" placeholder="Pesquisar placa…" [(ngModel)]="launchSearch">
          <input class="form-control form-control-sm launch-bulk" type="number" min="0" step="0.01" placeholder="Mensal p/ todos" [(ngModel)]="bulkUnitAmount">
          <button type="button" class="btn btn-sm btn-outline-primary" (click)="applyBulkUnitToSelected()">Aplicar valor</button>
        </div>
        <div class="lines-scroll" *ngIf="!launching && launchLines.length">
          <table class="table table-sm align-middle">
            <thead>
              <tr>
                <th></th>
                <th>Placa</th>
                <th>Pedido</th>
                <th>Dias</th>
                <th>Mensal (R$)</th>
                <th class="text-end">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let line of filteredLaunchLines">
                <td><input type="checkbox" [(ngModel)]="line.selected"></td>
                <td>{{ line.plate || '—' }}</td>
                <td>{{ line.itemNumber || line.b2BContractItemId || '—' }}</td>
                <td style="max-width:90px">
                  <input class="form-control form-control-sm" type="number" min="1" max="30" step="1" [(ngModel)]="line.quantity">
                </td>
                <td style="max-width:120px">
                  <input class="form-control form-control-sm" type="number" min="0" step="0.01" [(ngModel)]="line.unitAmount">
                </td>
                <td class="text-end">{{ formatMoney(lineAmount(line)) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="mt-2" *ngIf="!launching">
          <strong>{{ selectedLaunchCount }}</strong> veículo(s) ·
          Total <strong>{{ formatMoney(launchTotal) }}</strong>
        </p>
        <div class="wizard-actions">
          <button type="button" class="btn btn-outline-secondary" (click)="goStep('type')">Voltar</button>
          <button type="button" class="btn btn-success" [disabled]="saving || launching" (click)="saveLaunchAndContinue()">
            {{ saving ? 'Salvando…' : 'Salvar e ir para prévia' }}
          </button>
        </div>
      </div>

      <!-- LAUNCH RESERVE -->
      <div class="b2b-ops-card wizard-panel" *ngIf="step==='launch' && selectedCategory==='Reserve'">
        <h3>Lançar moto reserva por placa</h3>
        <p class="lead">
          Placas do contrato. Selecione todas ou algumas, pesquise e aplique a mensalidade em lote.
        </p>
        <div *ngIf="launching" class="text-muted py-3">Carregando placas…</div>
        <div class="diag-banner" *ngIf="!launching && !launchLines.length">
          Nenhuma placa ativa neste contrato. Cadastre veículos nos pedidos ou ajuste o período.
        </div>
        <div class="launch-toolbar" *ngIf="!launching && launchLines.length">
          <label class="launch-check">
            <input type="checkbox" [(ngModel)]="allFilteredLaunchSelected">
            Selecionar todos ({{ filteredLaunchLines.length }})
          </label>
          <input class="form-control form-control-sm launch-search" type="search" placeholder="Pesquisar placa…" [(ngModel)]="launchSearch">
          <input class="form-control form-control-sm launch-bulk" type="number" min="0" step="0.01" placeholder="Mensal p/ todos" [(ngModel)]="bulkUnitAmount">
          <button type="button" class="btn btn-sm btn-outline-primary" (click)="applyBulkUnitToSelected()">Aplicar valor</button>
        </div>
        <div class="lines-scroll" *ngIf="!launching && launchLines.length">
          <table class="table table-sm align-middle">
            <thead>
              <tr>
                <th></th>
                <th>Placa</th>
                <th>Pedido</th>
                <th>Dias</th>
                <th>Mensal (R$)</th>
                <th class="text-end">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let line of filteredLaunchLines">
                <td><input type="checkbox" [(ngModel)]="line.selected"></td>
                <td>{{ line.plate || '—' }}</td>
                <td>{{ line.itemNumber || line.b2BContractItemId || '—' }}</td>
                <td style="max-width:90px">
                  <input class="form-control form-control-sm" type="number" min="1" max="30" step="1" [(ngModel)]="line.quantity">
                </td>
                <td style="max-width:120px">
                  <input class="form-control form-control-sm" type="number" min="0" step="0.01" [(ngModel)]="line.unitAmount">
                </td>
                <td class="text-end">{{ formatMoney(lineAmount(line)) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="mt-2" *ngIf="!launching">
          <strong>{{ selectedLaunchCount }}</strong> moto(s) ·
          Total <strong>{{ formatMoney(launchTotal) }}</strong>
          (mensalidade × dias ÷ 30)
        </p>
        <div class="wizard-actions">
          <button type="button" class="btn btn-outline-secondary" (click)="goStep('type')">Voltar</button>
          <button type="button" class="btn btn-success" [disabled]="saving || launching" (click)="saveLaunchAndContinue()">
            {{ saving ? 'Salvando…' : 'Salvar e ir para prévia' }}
          </button>
        </div>
      </div>

      <!-- LAUNCH ACCESSORY -->
      <div class="b2b-ops-card wizard-panel" *ngIf="step==='launch' && selectedCategory==='Accessory'">
        <h3>Lançar acessórios do período</h3>
        <p class="lead">
          Espelho de <strong>todas as placas</strong> do contrato. Escolha o tipo, quantidade e valor
          <em>acima</em> e aplique nas selecionadas — não precisa saber a placa de antemão.
        </p>

        <div class="b2b-ops-filters mb-3" *ngIf="!launching">
          <div class="form-group" style="min-width:220px">
            <label class="form-label">Tipo de acessório</label>
            <select class="form-select" [(ngModel)]="bulkAccessoryId" (ngModelChange)="onBulkAccessoryChange()">
              <option [ngValue]="null">Selecione</option>
              <option *ngFor="let a of accessoriesCatalog" [ngValue]="a.id">
                {{ a.code ? a.code + ' — ' : '' }}{{ a.name }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label class="form-label">Qtd</label>
            <input class="form-control" type="number" min="1" [(ngModel)]="bulkAccessoryQty">
          </div>
          <div class="form-group">
            <label class="form-label">Valor unitário</label>
            <input class="form-control" type="number" min="0" step="0.01" [(ngModel)]="bulkAccessoryUnit">
          </div>
          <div class="form-group align-self-end">
            <button type="button" class="btn btn-primary" (click)="applyBulkAccessoryToSelected()">Aplicar nas selecionadas</button>
          </div>
        </div>

        <div *ngIf="launching" class="text-muted py-3">Carregando veículos…</div>
        <div class="diag-banner" *ngIf="!launching && !launchLines.length">Nenhum veículo no contrato.</div>

        <div class="launch-toolbar" *ngIf="!launching && launchLines.length">
          <label class="launch-check">
            <input type="checkbox" [(ngModel)]="allFilteredLaunchSelected">
            Selecionar todos ({{ filteredLaunchLines.length }})
          </label>
          <input class="form-control form-control-sm launch-search" type="search" placeholder="Pesquisar placa…" [(ngModel)]="launchSearch">
        </div>

        <div class="lines-scroll" *ngIf="!launching && launchLines.length">
          <table class="table table-sm align-middle">
            <thead>
              <tr>
                <th></th>
                <th>Placa</th>
                <th>Pedido</th>
                <th>Acessório</th>
                <th>Qtd</th>
                <th>Valor unit.</th>
                <th class="text-end">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let line of filteredLaunchLines">
                <td><input type="checkbox" [(ngModel)]="line.selected"></td>
                <td>{{ line.plate || '—' }}</td>
                <td>{{ line.itemNumber || line.b2BContractItemId || '—' }}</td>
                <td>{{ line.description || '—' }}</td>
                <td style="max-width:90px"><input class="form-control form-control-sm" type="number" min="0" [(ngModel)]="line.quantity"></td>
                <td style="max-width:120px"><input class="form-control form-control-sm" type="number" min="0" step="0.01" [(ngModel)]="line.unitAmount"></td>
                <td class="text-end">{{ formatMoney(lineAmount(line)) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="mt-2" *ngIf="!launching"><strong>{{ selectedLaunchCount }}</strong> placa(s) · Total: {{ formatMoney(launchTotal) }}</p>
        <div class="wizard-actions">
          <button type="button" class="btn btn-outline-secondary" (click)="goStep('type')">Voltar</button>
          <button type="button" class="btn btn-success" [disabled]="saving || launching" (click)="saveLaunchAndContinue()">
            {{ saving ? 'Salvando…' : 'Salvar e ir para prévia' }}
          </button>
        </div>
      </div>

      <!-- PREVIEW -->
      <div class="b2b-ops-card wizard-panel" *ngIf="!loading && step==='preview'">
        <h3>Prévia — {{ categoryLabel }}</h3>
        <p class="lead">
          {{ formatPeriodLabel(periodStart) }} → {{ formatPeriodLabel(periodEnd) }}
          ({{ previewLines.length }} linha(s) · {{ formatMoney(previewTotal) }}).
          <span *ngIf="preview"> · {{ preview.eligibleVehicleCount || 0 }} veículo(s) no contrato</span>
        </p>
        <div class="diag-banner info" *ngIf="preview?.diagnosticMessage">{{ preview?.diagnosticMessage }}</div>
        <div class="preview-toolbar" *ngIf="previewLines.length">
          <input class="form-control search" type="search" placeholder="Filtrar placa ou descrição…" [(ngModel)]="lineSearch">
        </div>
        <p *ngIf="!previewLines.length" class="diag-banner">
          Nenhuma linha nesta categoria/período.
          <span *ngIf="needsLaunchStep"> Volte ao lançamento e salve quantidade/valor.</span>
          <span *ngIf="!needsLaunchStep && (preview?.eligibleVehicleCount || 0) > 0">
            Há veículos no contrato — se o período já foi faturado, cancele o rascunho/fatura anterior ou escolha outro intervalo.
          </span>
        </p>
        <div class="lines-scroll" *ngIf="filteredPreviewLines.length">
          <table class="table table-sm">
            <thead>
              <tr>
                <th>Placa</th>
                <th>Descrição</th>
                <th>Data</th>
                <th>Qtd/Dias</th>
                <th class="text-end">Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let line of filteredPreviewLines | slice:0:previewPageSize">
                <td>{{ line.plate || '—' }}</td>
                <td>{{ line.description || '—' }}</td>
                <td>{{ formatLineDate(line.periodStart) }}</td>
                <td>{{ line.days ?? '—' }}</td>
                <td class="text-end">{{ formatMoney(line.amount) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="wizard-actions">
          <button type="button" class="btn btn-outline-secondary" (click)="needsLaunchStep ? goStep('launch') : goStep('type')">Voltar</button>
          <button type="button" class="btn btn-success" [disabled]="saving" (click)="createDraft()">
            {{ saving ? 'Salvando…' : 'Gerar rascunho' }}
          </button>
        </div>
      </div>

      <!-- DRAFTS -->
      <div class="b2b-ops-card wizard-panel" *ngIf="!loading && step==='drafts'">
        <h3>Rascunho gerado</h3>
        <p class="lead">Revise e exporte. Contas a Receber fica para etapa futura.</p>
        <div *ngIf="!drafts.length" class="diag-banner">Nenhum rascunho. {{ lastDraftMessage }}</div>
        <div class="draft-list mb-3" *ngIf="drafts.length">
          <div class="draft-row" *ngFor="let d of drafts" [class.active]="selectedDraft?.id === d.id" (click)="selectDraft(d)">
            <div>
              <strong>{{ d.invoiceNumber }}</strong>
              <div class="meta">{{ d.categoryLabel || d.category }} · {{ formatMoney(d.totalAmount) }}</div>
            </div>
          </div>
        </div>
        <div *ngIf="selectedDraft">
          <div class="lines-scroll mb-3">
            <table class="table table-sm">
              <thead>
                <tr>
                  <th>Placa</th>
                  <th>Descrição</th>
                  <th>Data</th>
                  <th>Qtd</th>
                  <th class="text-end">Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let line of selectedDraft.items | slice:0:previewPageSize">
                  <td>{{ line.plate || '—' }}</td>
                  <td>{{ line.description || '—' }}</td>
                  <td>{{ formatLineDate(line.periodStart) }}</td>
                  <td>{{ line.days ?? '—' }}</td>
                  <td class="text-end">{{ formatMoney(line.amount) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="wizard-actions">
            <button type="button" class="btn btn-success" (click)="exportDraft('xlsx')"><i class="fas fa-file-excel me-1"></i> Excel</button>
            <button type="button" class="btn btn-danger" (click)="exportDraft('pdf')"><i class="fas fa-file-pdf me-1"></i> PDF</button>
            <button type="button" class="btn btn-outline-secondary" (click)="closeWizard()">Fechar assistente</button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</app-side-menu>
